const HomeOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.34" height="27.127">
      <g data-name="グループ 57">
        <g data-name="グループ 56" fill="none" stroke-miterlimit="10">
          <g data-name="パス 60">
            <path d="M11.69.383L.466 10.734A1.442 1.442 0 000 11.796v13.111a2.15 2.15 0 002.057 2.22h5.739a1.446 1.446 0 001.446-1.445v-6.851a1.445 1.445 0 011.445-1.446h3.967a1.445 1.445 0 011.445 1.446v6.851a1.445 1.445 0 001.445 1.445h5.739a2.149 2.149 0 002.057-2.22V11.796a1.441 1.441 0 00-.465-1.062L13.65.383a1.445 1.445 0 00-1.96 0z" />
            <path
              d="M12.67 2.2L2 12.04v12.867c0 .12.053.195.083.22h5.159v-6.296a3.45 3.45 0 013.445-3.446h3.967a3.45 3.45 0 013.445 3.446v6.296h5.159c.029-.025.082-.1.082-.22V12.04l-10.67-9.84m0-2.2c.352 0 .703.128.98.384l11.225 10.351c.297.273.465.658.465 1.062v13.111c0 1.221-.925 2.22-2.057 2.22h-5.739a1.445 1.445 0 01-1.445-1.445v-6.851c0-.799-.647-1.446-1.445-1.446h-3.967c-.798 0-1.445.647-1.445 1.446v6.851c0 .798-.648 1.445-1.446 1.445H2.057C.926 27.127 0 26.128 0 24.907V11.796c0-.404.169-.79.466-1.062L11.69.383c.277-.256.629-.383.98-.383z"
              className="main-fill"
            />
          </g>
          <path data-name="線 24" className="main-stroke" stroke-width="2" d="M25.34 12.447H0" />
        </g>
      </g>
    </svg>
  )
}

export default HomeOnSvg
